/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WebhookEndpointDto } from '../../models/webhook-endpoint-dto';

export interface WebhooksEndpointsGet$Json$Params {
}

export function webhooksEndpointsGet$Json(http: HttpClient, rootUrl: string, params?: WebhooksEndpointsGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WebhookEndpointDto>>> {
  const rb = new RequestBuilder(rootUrl, webhooksEndpointsGet$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<WebhookEndpointDto>>;
    })
  );
}

webhooksEndpointsGet$Json.PATH = '/webhooks/endpoints';
